// import Endorsement from "@/components/Endorsement";
// ... rest of your code
// import Navbar from "@/components/Navbar";
// import Comingsoon from "@/components/ComingSoon";
import Header from "@/components/Header";
import Speakers from "@/components/Speakers";
import SpeakersFlyer from "@/components/SpeakersFlyer";
import ConferenceTopics from "@/components/ConferenceTopics";
import ConferenceTnV from "@/components/ConferenceTnV";
import Live from "@/components/LiveSession";
// import ConferencePricing from "@/components/ConferencePricing";

// import Sponsors from "@/components/Sponsors";

const Conference = () => {
  return (
    <>
      <Header />
      <Live />
      <section id="topics" className=" bg-gray-50">
        <ConferenceTopics />
      </section>
      <section id="speakers" className=" bg-white">
        <Speakers />
      </section>
      <div className="bg-gradient-to-bl from-white to-blue-50 pb-10">
        <SpeakersFlyer />
        <ConferenceTnV />
      </div>
      {/* <div className="min-h-screen bg-white">
        <ConferencePricing />
      </div> */}
      {/* <Endorsement /> */}

      {/* Important Dates */}
      {/* <section className="py-16 bg-blue-600 text-white">
        <h2 className="text-4xl font-bold text-center mb-12">
          Important Dates
        </h2>
        <ul className="space-y-4 text-lg text-center">
          <li>Abstract Submission Deadline: August 1, 2025</li>
          <li>Notification of Acceptance: September 1, 2025</li>
          <li>Early Bird Registration Deadline: October 1, 2025</li>
          <li>Conference Dates: November 6-8, 2025</li>
        </ul>
      </section> */}
    </>
  );
};

export default Conference;
